/** The product name every portal and player app shows (formerly Kiosk Gaming). */
export const BRAND_NAME = 'Vault Play';
/** Tier names are proper nouns: always this casing, never abbreviated (spec §2 rule 2–3). */
export const TIER_LABEL = {
    admin: { one: 'Admin', many: 'Admins' },
    super_agent: { one: 'Super Agent', many: 'Super Agents' },
    agent: { one: 'Agent', many: 'Agents' },
    shop: { one: 'Shop', many: 'Shops' },
    cashier: { one: 'Cashier', many: 'Cashiers' },
    player: { one: 'Player', many: 'Players' },
    platform: { one: 'Platform', many: 'Platform' },
};
function toTier(raw) {
    const key = String(raw !== null && raw !== void 0 ? raw : '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    return (key in TIER_LABEL ? key : null);
}
export function tierLabel(tier, opts) {
    const t = toTier(tier);
    if (!t)
        return '';
    return (opts === null || opts === void 0 ? void 0 : opts.plural) ? TIER_LABEL[t].many : TIER_LABEL[t].one;
}
export const PORTAL_NAME = {
    admin: 'Admin portal',
    super_agent: 'Super Agent portal',
    agent: 'Agent portal',
    shop: 'Shop portal',
    cashier: 'Cashier portal',
};
export function documentTitle(page, portal) {
    const parts = [page.trim(), tierLabel(portal), BRAND_NAME].filter(Boolean);
    return parts.join(' · ');
}
